export function getValueByPropertyStringPath(object, propertyPath) {
  return propertyPath.split(".").reduce((o, i) => o[i], object);
}

export function deepClone(object) {
  return JSON.parse(JSON.stringify(object));
}

export function jsonEqual(a, b) {
  return JSON.stringify(a) === JSON.stringify(b);
}

export function getProperty(object, property, fallback = undefined) {
  if (object && object[property] != null) return object[property];
  return fallback;
}

export function getSubobject(object, properties) {
  const newObject = {};
  for (const property of properties) {
    newObject[property] = object[property];
  }
  return newObject;
}
